/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

// REST resourses
export const RESOURCE_VERSION_V2 = "/v2";
export const RESOURCE_LOGIN = "/login";
export const RESOURCE_API = "/apis";
export const RESOURCE_ORGANIZATION = "/orgs";
export const RESOURCE_METADATA = "/orgs/1.0.0/orgs-metadata";
export const RESOURCE_DOMAIN = "/domains"; // @TODO: Remove this later once fully moved to v2
export const RESOURCE_CUSTOM_DOMAIN = "/customdomains";
export const RESOURCE_OVERVIEW = "/overview";
export const RESOURCE_API_COMMENTS = "/comments";
export const RESOURCE_API_TRYOUT = "/tryout";
export const RESOURCE_API_CREDENTIALS = "/credentials";
export const RESOURCE_API_RATINGS = "/ratings";
export const RESOURCE_USER_RATING = "/user-rating";
export const RESOURCE_API_DOCUMENTS = "/documents";
export const RESOURCE_API_DOCUMENT_CONTENT = "/DOCUMENT_ID/content";
export const RESOURCE_SIGN_IN = "/sign-in";
export const RESOURCE_APP_KEYS = "/oauth-keys";
export const RESOURCE_GENERATE_APP_KEYS = "/generate-keys";
export const RESOURCE_GENERATE_TEST_KEY = "/generate-key";
export const RESOURCE_GENERATE_TOKEN = "/KEY_MAPPING_ID/generate-token";
export const RESOURCE_CLEAN_UP_APP_KEYS = "/KEY_MAPPING_ID/clean-up";
export const RESOURCE_SWAGGER = "/swagger";
export const RESOURCE_ASYNCAPI = "/asyncapi";
export const RESOURCE_THUMBNAIL = "/thumbnail";
export const RESOURCE_GENERATE_SDK = "/sdks/LANGUAGE";
export const RESOURCE_LANGUAGE_SDK = "/sdk-gen/languages";
export const RESOURCE_APPLICATIONS = "/applications";
export const RESOURCE_TAGS = "/tags";
export const RESOURCE_CATEGORIES = "/api-categories";
export const RESOURCE_SUBSCRIPTIONS = "/subscriptions";
export const RESOURCE_API_KEY = "/api-keys";
export const RESOURCE_GENERATE = "/generate";
export const RESOURCE_THROTTLING_POLICIES = "/throttling-policies";
export const RESOURCE_INTERNAL_ERROR = "/internal-error";
export const RESOURCE_CLIENT_ERROR = "/client-error";
export const RESOURCE_TOKEN = "/token";
export const RESOURCE_AUTHORIZE = "/authorize";
export const RESOURCE_REVOKE = "/revoke";
export const RESOURCE_OAUTH2 = "/oauth2";
export const AUTHORIZATION_ERROR = "/unauthorized/";
export const RESOURCE_IDPS = "/key-managers";
export const MAP_APPLICATION_KEYS = "/map-keys";
export const RESOURCE_CUSTOM_DOMAIN_MAPPINGS = "/mappings";
export const PATH_DEVPORTAL = "/devportal";
export const RESOURCE_SHARE_APPLICATION = "/share";
export const RESOURCE_ENV_CONFIGS = "/settings/environments"

// HTTP Codes
export const RESOURCE_NOT_FOUND = 404;
export const BAD_REQUEST = 400;

// HTTP Protocols
export const PROTOCOL_HTTPS = "https://";
export const PROTOCOL_WSS = "wss://";

// API types
export const API_TYPE_HTTP = "HTTP";
export const API_TYPE_GRAPHQL = "GraphQL";
export const API_TYPE_WS = "WS";

// User claims
export const CLAIMS_USERNAME = "username";
export const CLAIMS_FULL_NAME = "name";
export const CLAIMS_EMAIL = "email";
export const CLAIMS_GOOGLE_PIC = "google_pic_url";
export const CLAIMS_GITHUB_PIC = "github-pic-url";
export const CLAIMS_PHOTO_URL = "photourl";
export const CLAIMS_AVATAR_URL = "avatar_url";
export const CLAIMS_PICTURE = "picture";

// Application grant types
export const AUTHORIZATION_CODE_GRANT_TYPE = 'authorization_code';
export const CLIENT_CREDENTIALS_GRANT_TYPE = 'client_credentials';
export const IMPLICIT_GRANT_TYPE = 'implicit';

// Subscription throttling policy
export const SUBSCRIPTION_THROTTLING_POLICY_UNLIMITED = "Unlimited";

// Other constants
export const RETURN_TO_PATH = "RETURN_TO_PATH";
export const CREATED_BY_USER = "CREATED_BY_USER";
export const SELECTED_ORG_UUID = "SELECTED_ORG_UUID";
export const CORRELATION_ID = "CORRELATION_ID";
export const SELECTED_ORG_HANDLE_NAME = "SELECTED_ORG_HANDLE_NAME";
export const FORBIDDEN_SELECTED_ORG_HANDLE_NAME = "FORBIDDEN_SELECTED_ORG_HANDLE_NAME";
export const FIDP = "FIDP";
export const GOOGLE_IDP = "google";
export const GITHUB_IDP = "github";
export const DEFAULT_APP_INTERNAL_PREFIX = "_internal_";
export const DEFAULT_ASGARDEO_KEY_MANAGER_PREFIX = "_internal_key_manager_";
export const APPDEV_STS_KEY_MANAGER_TYPE = "ChoreoAppDevSTS";
export const ASGARDEO_KEY_MANAGER_TYPE = "Asgardeo";
export const AZURE_KEY_MANAGER_TYPE = "Microsoft";
export const RESIDENT_KEY_MANAGER_NAME = "Resident Key Manager";
export const ORG_ID = "ORG_ID";
export const ORG_QUERY_PARAM = "orgUuid";
export const CORRELATION_ID_QUERY_PARAM = "correlationId";
export const DEFAULT_API_GATEWAY_SUFFIX = ".dv.choreoapis.dev";
export const CP_GATEWAY_ENV_HOST = ".preview-dv.choreo.dev";
export const CONTROL_PLANE_ORG = "Choreo Control Plane";
export const MAX_APPLICATION_NAME_LENGTH = 70;
export const MAX_APPLICATION_DESCRIPTION_LENGTH = 512;
export const MAX_DESCRIPTION_LENGTH = 200;
export const PATH_SEPARATOR = "/";
export const DASH_SEPARATOR = "-";
export const MAX_RETRY_COUNT = 3;
export const HOME_PAGE_API_QUERY = "/apis?query=api-category:featured";
export const API_TAGS_QUERY = "/apis?query=tags:";
export const API_CATEGORY_QUERY = "/apis?query=api-category:";
export const API_DISPLAY_NAME_QUERY = "/apis?query=display-name:";
export const API_GENERAL_QUERY = "/apis?query=";
export const RGB_ALPHA = "ALPHA";
export const DEFAULT_RGB_ALPHA = "0.15";
export const DEFAULT_API_TAGS_COLOR = "rgba(166, 179, 255, ALPHA)";
export const SUBSCRIPTION_POLICY_TYPE = "subscription";
export const ALL = "*";
export const ENVIRONMENTS = {
  PRODUCTION: "PRODUCTION",
  SANDBOX: "SANDBOX",
};
export const MAX_COMMENT_LENGTH = 450;
export const KEY_ENTER = "Enter";
export const VALUE_ZERO = 0;
export const VALUE_ONE = 1;
export const API_COUNT_PER_PAGE = 5;
export const API_PAGINATION_QUERY =
  "/apis?limit={LIMIT}&&offset={OFFSET}&query=";
export const NOT_FOUND_ERROR = 'not-found-error';
export const HTTP_METHODS = {
  GET: "get",
  PUT: "put",
  POST: "post",
  DELETE: "delete",
  PATCH: "patch",
  HEAD: "head",
  OPTIONS: "options",
};
export const WS_METHODS = {
  PUBLISH: "pub",
  SUBSCRIBE: "sub",
};
export const ORG_NOT_AVAILABLE = 'org-not-available';
export const CONTENT_TYPE = "Content-Type";
export const APPLICATION_JSON = "application/json";
export const LOGIN_REQUIRED = "login_required";

// Access control scopes
export const PRODUCTION_KEY_MANAGE_SCOPE = "apim:prod_key_manage";
export const SANDBOX_KEY_MANAGE_SCOPE = "apim:sand_key_manage";
export const SUBSCRIBE_SCOPE = "apim:subscribe";

export const DOC_HOME_URL = 'https://wso2.com/choreo/docs/';
// Application Key Documentation Links
export const AZURE_CLIENT_ID_DOC_URL = `${DOC_HOME_URL}authentication-and-authorization/secure-api-access-with-azure-ad/#step-4-create-an-application-in-choreo-and-enable-external-idp-authentication`;
export const ASGARDEO_CLIENT_ID_DOC_URL = `${DOC_HOME_URL}authentication-and-authorization/secure-api-access-with-asgardeo/#step-3-create-an-application-in-choreo-and-enable-external-idp-authentication`;

export const MAJOR_VERSION = "majorVersion";

export const DEVELOPMENT = "Development";
export const PRODUCTION = "Production";
export const INTERNAL = "internal";

export const QUERY_PARAM_VALUE_OWNER_INFO = "ownerInfo";

export const APPROVAL_STATUS_APPROVED = "APPROVAL_STATUS_APPROVED";
export const USER_NOT_FOUND = "USER_NOT_FOUND";

export const APPROVAL_STATUS_APPROVED_CODE = 1023;
export const USER_NOT_FOUND_CODE = 1020;

export const ADMIN_SCOPE = "apim:admin"
export const DEFAULT_APPLICATION_LIMIT = 150;
